<template>
  <!-- 批量申请待审批列表 -->
  <div class="batch-audit-list">
    <a-card style="margin-bottom: 10px">
      <search-view
        :renderItem="BATCH_SEARCH_SCHEMA"
        :isExpandShowOrNot="false"
        :initialValues="initSearchForm"
        @fetchSearch="handleSearch"
      ></search-view>
    </a-card>

    <a-card>
      <table-view
        :data="tableData"
        :columns="columns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="SCROLL"
        @handlePagination="handlePagination"
      >
        <template v-slot:totalAmount="{ tableRow }">
          <span>
            {{ tableRow.totalAmount | formatAmount }}
          </span>
        </template>
        <template v-slot:maxAmount="{ tableRow }">
          <span>
            {{ tableRow.maxAmount | formatAmount }}
          </span>
        </template>
        <template v-slot:action="{ tableRow }">
          <a-button type="link" size="small" @click="handleView(tableRow)">
            审核
          </a-button>
        </template>
      </table-view>
    </a-card>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import cloneDeep from 'lodash/cloneDeep'
import { BATCH_SEARCH_SCHEMA } from './schema'
import { getBatchAuditList } from './api'
import { formatParamDate } from 'utils/util'

export default {
  name: 'batch-audit-list',
  data() {
    const initSearchForm = {
      endTime: '',
      startTime: '',
      id: '',
    }
    const searchForm = cloneDeep(initSearchForm)
    return {
      BATCH_SEARCH_SCHEMA,
      tableLoading: false,
      initSearchForm,
      searchForm,
      tableData: [],
      columns: [
        {
          title: '序号',
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
          width: 80,
          fixed: 'left',
        },
        {
          title: '流水号',
          dataIndex: 'bpmId',
          // width: 220
        },
        {
          title: '申请人',
          dataIndex: 'applier',
          width: 120,
        },
        {
          title: '申请日期',
          dataIndex: 'applyDate',
          width: 150,
        },
        {
          title: '申请总金额(元)',
          scopedSlots: { customRender: 'totalAmount' },
          width: 200,
        },
        {
          title: '最高金额(元)',
          scopedSlots: { customRender: 'maxAmount' },
          width: 200,
        },
        {
          title: '信用类型',
          dataIndex: 'typeStr',
          width: 100,
        },
        {
          title: '审批角色',
          dataIndex: 'approveRole',
          width: 150,
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: 100,
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
          width: 100,
          fixed: 'right',
        },
      ],
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      SCROLL: { x: 1450 },
    }
  },
  mounted() {
    this._getBatchAuditList(this.initSearchForm)
  },
  methods: {
    async _getBatchAuditList(searchForm) {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        ...searchForm,
        size: pageSize,
        current,
      }
      try {
        const {
          data: { total, records },
        } = await getBatchAuditList(formData)
        this.pageData.total = total
        this.tableData = records.map(item => {
          item.id = item.bpmId
          return item
        })
        this.tableLoading = false
      } catch (error) {
        console.error(error)
      }
    },
    handleSearch(data) {
      data = formatParamDate(data, data.applyRangeDate)
      delete data.applyRangeDate
      this.searchForm = data
      this.pageData.current = 1 // 设置为第一页
      this._getBatchAuditList(data)
    },
    handlePagination(pagination) {
      ;({
        current: this.pageData.current,
        pageSize: this.pageData.pageSize,
        total: this.pageData.total,
      } = pagination)
      this._getBatchAuditList(this.searchForm)
    },
    handleView(row) {
      this.$router.push({
        path: `/credit-approval/audit/batch-approval-detail/${row.id}`,
      })
    },
  },
  components: {
    SearchView,
    TableView,
  },
}
</script>

<style></style>
